import { useMutation } from "react-query";
import { endpoints } from "utils/endpoints";
import http from "utils/http";

const addForgetPassword = (postData) => {
  return http().post(endpoints.forms.forgetPassword, postData);
};

export function useForgetPassword() {
  return useMutation(addForgetPassword, {
    onError: (errorData) => {
      const errorMessage = errorData?.error?.message || errorData?.message;
      alert(errorMessage);
    },
  });
}
